// components/ui/modals/TrailerAssociationModal.jsx
import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as WarningIcon } from "../../../assets/svg/components/alert.svg";//warning icon
import { ReactComponent as CloseIcon } from "../../../assets/svg/view/close_circle.svg";
import "../../../assets/scss/components/vehicle/TrailerAssociationModal.scss";

const TrailerAssociationModal = ({
  open,
  onClose,
  onConfirm,
  trailerData,
  conflictData,
  theme,
  isLoading = false
}) => {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm(true); // forceAssociation = true
  };

  return (
    <div className={`GM__${theme}-modal-overlay`}>
      <div className={`GM__${theme}-trailer-association-modal`}>
        <div className={`GM__${theme}-modal-header`}>
          <div className={`GM__${theme}-modal-title-container`}>
            <WarningIcon className={`GM__${theme}-warning-icon`} />
            <h3 className={`GM__${theme}-modal-title`}>
              Trailer ya está asociado
            </h3>
          </div>
          <button
            className={`GM__${theme}-close-button`}
            onClick={onClose}
            disabled={isLoading}
          >
            <CloseIcon />
          </button>
        </div>

        <div className={`GM__${theme}-modal-content`}>
          <div className={`GM__${theme}-conflict-info`}>
            <p className={`GM__${theme}-conflict-message`}>
              El trailer <strong>{trailerData?.plate}</strong> ya está asociado al vehículo{" "}
              <strong>{conflictData?.associatedToVehicle}</strong>.
            </p>
            
            <div className={`GM__${theme}-conflict-details`}>
              <h4>¿Qué sucederá si continúas?</h4>
              <ul>
                <li>El trailer se desasociará automáticamente del vehículo actual</li>
                <li>Se asociará al vehículo que estás editando</li>
                <li>Se registrará esta acción en el historial de ambos vehículos</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={`GM__${theme}-modal-actions`}>
          <button
            className={`GM__${theme}-cancel-button`}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            className={`GM__${theme}-confirm-button`}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Procesando..." : "Continuar con la asociación"}
          </button>
        </div>
      </div>
    </div>
  );
};

TrailerAssociationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  trailerData: PropTypes.object,
  conflictData: PropTypes.object,
  theme: PropTypes.oneOf(["dark", "light"]).isRequired,
  isLoading: PropTypes.bool
};

export default TrailerAssociationModal;